import { Link } from "react-router-dom";

export function PrivacyPage() {
  return (
    <div data-testid="privacy-page" className="pt-20">
      <section className="py-16 bg-[#0F2137]">
        <div className="container-custom"><h1 className="text-5xl font-bold text-white">Privacy Policy</h1></div>
      </section>
      <section className="py-24 bg-white">
        <div className="container-custom max-w-3xl prose prose-lg">
          <p className="text-[#495057] leading-relaxed">Lane4 is committed to protecting your privacy. This policy outlines how we collect, use, and safeguard your personal information when you use our services.</p>
          <h2 className="text-2xl font-bold text-[#0F2137] mt-8 mb-4">Information We Collect</h2>
          <p className="text-[#495057] leading-relaxed">We collect information you provide directly, such as when you make a purchase, submit a contact form, or sign up for our services.</p>
          <h2 className="text-2xl font-bold text-[#0F2137] mt-8 mb-4">How We Use Your Information</h2>
          <p className="text-[#495057] leading-relaxed">Your information is used to process orders, respond to inquiries, and improve our services. We do not sell your personal information to third parties.</p>
          <h2 className="text-2xl font-bold text-[#0F2137] mt-8 mb-4">Contact Us</h2>
          <p className="text-[#495057] leading-relaxed">If you have questions about this policy, contact us at <a href="mailto:info@lane4.org" className="text-[#D90429] hover:underline">info@lane4.org</a>.</p>
        </div>
      </section>
    </div>
  );
}

export function RefundPage() {
  return (
    <div data-testid="refund-page" className="pt-20">
      <section className="py-16 bg-[#0F2137]">
        <div className="container-custom"><h1 className="text-5xl font-bold text-white">Refund Policy</h1></div>
      </section>
      <section className="py-24 bg-white">
        <div className="container-custom max-w-3xl prose prose-lg">
          <h2 className="text-2xl font-bold text-[#0F2137] mb-4">Event Tickets</h2>
          <p className="text-[#495057] leading-relaxed">All ticket sales are final. Refunds may be issued if an event is cancelled by the organizer. Please contact the event organizer directly for event-related refund requests.</p>
          <h2 className="text-2xl font-bold text-[#0F2137] mt-8 mb-4">Merchandise</h2>
          <p className="text-[#495057] leading-relaxed">Merchandise returns are accepted within 30 days of purchase for unworn, unwashed items with original tags. Contact us at <a href="mailto:support@lane4.org" className="text-[#D90429] hover:underline">support@lane4.org</a> to initiate a return.</p>
          <h2 className="text-2xl font-bold text-[#0F2137] mt-8 mb-4">Custom Medals</h2>
          <p className="text-[#495057] leading-relaxed">Due to the custom nature of our medals, all medal orders are final once production begins. Please review your design carefully before approving.</p>
        </div>
      </section>
    </div>
  );
}
